import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useRouter } from '@bibliocommons/utils-routing';
import { SolidButton } from '@bibliocommons/base-buttons';

import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';
import Heading from 'app/components/shared/Heading';
import Checkbox from 'app/components/shared/Checkbox';
import { selectFacilityTypeEntities } from 'app/selectors/EntitiesSelector';
import OpenNowFilter from '../OpenNowFilter';

import './LocationsSearchFilters.scss';

export default function LocationsSearchFilters({ handleClose }) {
  const router = useRouter();
  const allFacilities = useSelector(selectFacilityTypeEntities).toList();
  const [selectedFacilities, setSelectedFacilities] = useState(router.query.facilities?.split(',') || []);
  const [openNow, setOpenNow] = useState(router.query.open === 'true');

  function handleSave() {
    handleClose();
    router.push({
      query: {
        ...router.query,
        open: openNow,
        facilities: selectedFacilities.join(',')
      }
    });
  }

  function handleFacilitySelect(selected, facility) {
    if (selected) {
      setSelectedFacilities([...selectedFacilities, facility.get('id')]);
    } else {
      setSelectedFacilities(selectedFacilities.filter(id => id !== facility.get('id')));
    }
  }

  return (
    <div className="cp-locations-search-filters">
      <ModalHeader title={<FormattedMessage id="locations_filters" />} />
      <ModalContent>
        <div className="filters">
          <Heading tagName="h4" size="modest">
            <FormattedMessage id="hours" />
          </Heading>
          <p>
            <OpenNowFilter id="hours-open-now" handleChange={setOpenNow} checked={openNow} />
          </p>
          <Heading tagName="h4" size="modest">
            <FormattedMessage id="facilities" />
          </Heading>
          <ul className="facilities-grid">
            {allFacilities.map(facility => (
              <li key={facility.get('id')}>
                <Checkbox
                  dataKey="facility-checkbox"
                  label={facility.get('label')}
                  id={`facility-${facility.get('id')}`}
                  checked={selectedFacilities.includes(facility.get('id'))}
                  handleChange={selected => handleFacilitySelect(selected, facility)}
                />
              </li>
            ))}
          </ul>
        </div>
      </ModalContent>
      <ModalFooter
        primaryActionButtonText={<FormattedMessage id="done" />}
        primaryActionButtonTag={SolidButton}
        handlePrimaryAction={handleSave}
      />
    </div>
  );
}

LocationsSearchFilters.propTypes = {
  handleClose: PropTypes.func.isRequired
};
